import React, {useEffect} from "react";
import {postConfiguration} from "api";
import {Guid} from "utilities";
import {Query} from "utilities/query";
import {Cookie} from "utilities";
import {useLogger} from "hooks";

// https://test.cyri.systemrequirementslab.com/detect/?ref-id=1244&config-id=[4,0,3]&os=CrOS&user-id=541&next=%2Fclientblaze%2Fanalysis%2Fconfig%2F1%2F%3Fappkey%3DD746F0C7-FAA5-414C-B47B-B45A3BCF1E98%26refid%3D1244%26itemid%3D19768%26type%3Dform

/**
 * Get the computer ID from a cookie or query string.
 *
 */
// const getCookies = (referrerID) => {
//   // First try the query string.
//   // let query = new Query();
//   // let id = query.get("computer-id");
//   // if (!id) {

//   let ret = {};
//   let cookie;

//   // Use the client type cookie first.
//   cookie = Cookie.clientCookie(null, referrerID);
//   ret.id = cookie.get();

//   if (!ret.id && referrerID === "1046") {
//     // Try the CYRI cookie.
//     cookie = Cookie.cyriCookie(null);
//     ret.id = cookie.get();
//   }

//   // Check if it's valid.
//   if (!Guid.isValid(ret.id)) {
//     ret.id = Guid.newGuid(); // For an illegal id generate a new one.
//   }

//   // if (referrerID.toString() === "1046") {
//   // } else {
//   // }
//   // // Try the client computer id cookie.
//   // ret.id = cookie.get();
//   // // Try the older computer id cookie.
//   // if (!ret.id) {
//   //   ret.id = cyriCookie.get();
//   // }
//   //}

//   return ret;
// };

/**
 * Get the system ID. If it doesn't exist then create one.
 */

const getCookies = () => {
    let cookie = Cookie.systemIdCookie();
    let id = (cookie.get() ?? "").toUpperCase();
    //  if (!id || id === "") {
    // Create cookie and save it.
    //    id = Guid.newGuid();
    //    id = fallbackCookie;
    //    cookie.value = fallbackCookie;
    //    cookie.set();
    //  }
    return {systemId: id};
};

/**
 *
 * Get the referrer configuration off of the server.
 *
 */

// let getReferrerConfiguration = async (
//   referrerID,
//   requirementSetID,
//   sessionID
// ) => {
//   var c = await Promise.all([
//     getConfiguration(referrerID, requirementSetID, sessionID),
//   ]);
//   let configuration = c[0];

//   // Handle an error by generating basic configuration so we can continue. Shouldn't ever happen.
//   // TODO: Log this.
//   if (!configuration) {
//     configuration = {
//       detection: {},
//     };
//   }
//   if (!configuration.detection) {
//     configuration.detection = {};
//   }

//   return configuration;
// };

/**
 *
 * Get the referrer configuration off of the server.
 *
 */

// let postReferrerConfiguration = async () => {
//   var c = await Promise.all([
//     getConfiguration(referrerID, requirementSetID, sessionID),
//   ]);
//   let configuration = c[0];

//   // Handle an error by generating basic configuration so we can continue. Shouldn't ever happen.
//   // TODO: Log this.
//   if (!configuration) {
//     configuration = {
//       detection: {},
//     };
//   }
//   if (!configuration.detection) {
//     configuration.detection = {};
//   }

//   return configuration;
// };

/** Get query string parameters.
 *
 */
const getQueryParameters = () => {
    let ret = {};
    let query = new Query();

    // Get referrer ID from the query.
    ret.referrerId = Number(query.get("ref-id")) | 0;
    if (ret.referrerId === 0) {
        ret.referrerId = 1046; // No referrer ID so run with CYRI as default.
    }

    // Get requirement set ID from the query.
    // TODO: Fix this to handle lists.
    //ret.requirementSetId = Number(query.get("config-id")) | 0;

    // 12345|54321
    // 12345

    let requirementSetId = query.get("config-id");
    
    if (!requirementSetId) {
        requirementSetId = "0";
    }
    
    let sets = requirementSetId.split("|");
    
    ret.requirementSetIds = sets.map(Number);
    ret.requirementSetId = (sets.length > 0) ? sets[0] : 0;
    
    // if (!ret.requirementSetID) {
    //   ret.requirementSetID = "0"; // No requirement set so use 0 as default.
    // }

    // Get user ID from the query.
    ret.userId = query.get("user-id") ?? "";

    // Computer ID.
    ret.computerId = (query.get("computer-id") ?? "").toUpperCase();

    // Session ID.
    // ret.sessionID = (query.get("id") ?? "").toUpperCase();
    //console.log("sessionID = " + ret.sessionID + "X");

    // Next URL.
    ret.next = decodeURIComponent(query.get("next")) ?? "";

    // Error URL.
    ret.error = decodeURIComponent(query.get("error")) ?? "";

    // Network test special.
    // TODO: Fix this to handle boolean.
    ret.networkTestOnly = query.get("network-test") ?? "";

    return ret;
};

/**
 *  The context.
 */
export const ConfigurationContext = React.createContext(null);

/**
 *  The Context Provider.
 *
 *  @param {} props
 */
export const ConfigurationContextProvider = (props) => {
    const [state, setState] = React.useState(null);

    useEffect(() => {
        let get = async () => {
            let query = getQueryParameters();
            let cookies = getCookies();

            // let systemId = getSystemIdCookie();

            // console.log(`set id: ${query.requirementSetID}`);

            // Computer ID.
            // let computerID = query.computerID;
            // if (!Guid.isValid(computerID)) {
            //   // Use the cookie value when no override from the query.
            //   computerID = cookies.id;
            // }

            // Get the configuration from the API and use it as the base to build on.
            // let configuration = await getReferrerConfiguration(
            //   query.referrerID,
            //   query.requirementSetID,
            //   query.sessionID,
            //   computerID
            // );

            // Send configuration information to server and get back processed and added configuration.
            //let configuration = ;

            //console.log("Posting configuration");
            let configuration = await postConfiguration({...cookies, ...query});
            //console.log("Configuration: " + JSON.stringify(configuration));

            // Merge everything.
            configuration = {...cookies, ...query, ...configuration};

            // Set the system id cookie.
            let cookie = Cookie.systemIdCookie();
            cookie.value = configuration.systemId;
            cookie.set();

            // Is there a valid override?
            // if (Guid.isValid(computerID)) {
            //   configuration.computerID = computerID;
            // }

            // Build onto the configuration.

            // Some helpers.

            let tempOS = configuration.os ? configuration.os.toLowerCase() : "";
            configuration.isWindows = tempOS.includes("win");
            configuration.isMacOS = tempOS.includes("mac");
            configuration.isChromeOS = tempOS.includes("chrome");

            // System ID.
            // configuration.systemId =        getSystemIdCookie(configuration.systemId);

            // configuration.systemId = systemId;
            // if (!Guid.isValid(configuration.systemId))
            // {
            //   // Use a GUID from the server.
            //   configuration.systemId = configuration.guid2;
            // }

            // RequirementSet ID.
            //      configuration.requirementSetID = query.requirementSetID;

            //  console.log(configuration.computerID);

            // Next URL.
            // if (!configuration.next || 0 === configuration.next.length) {
            //   // Use the query value if missing.
            //   configuration.next = query.nextUrl;

            //   if (!configuration.next || 0 === configuration.next.length) {
            //     // Use the referrer url if missing.
            //     configuration.next = document.referrer;
            //   }
            // }

            // Add any substitutions to the next url.

            // configuration.next = configuration.next.replace(
            //   "{{systemId}}

            // Error URL. TODO: I don't even know if this is a thing anymore.
            // if (!configuration.error || 0 === configuration.next.length) {
            //   // Use the query value if missing.
            //   configuration.error = query.errorUrl;

            //   if (!configuration.error || 0 === configuration.next.length) {
            //     // Use the next url if missing.
            //     configuration.error = configuration.next;
            //   }
            // }

            // Set up the steps.

            configuration.steps = {
                start: true, // Always.
                browserDetection: true, // Always.
                appDetection: configuration.detection.app,
                //          configuration.detection.macApp || configuration.detection.winApp || configuration.detection.chromeApp,
                macApp: configuration.isWindows && configuration.detection.app,
                winApp: configuration.isMacOS && configuration.detection.app,
                chromeApp: configuration.isChromeOS && configuration.detection.app,
                //  speedTestDetection: configuration.detection.networkSpeed || configuration.detection.networkLatency,
                networkDetection:
                    configuration.detection.ookla ||
                    configuration.detection.standardLatency ||
                    configuration.detection.standardSpeed, //                       //configuration.detection.networkSpeed || configuration.detection.networkLatency,

                ookla: configuration.detection.ookla,

                standard:
                    configuration.detection.standardLatency |
                    configuration.detection.standardSpeed,

                standardLatency: configuration.detection.standardLatency,
                standardSpeed: configuration.detection.standardSpeed,

                networkTestService: configuration.detection.networkTestService,

                finish: true,
            };

            // Network test special case.
            if (query.networkTestOnly) {
                configuration.steps.appDetection = false;
                configuration.steps.networkDetection = true;
            }

            // Network test endpoints.
            configuration.networkTestEndpoints = {
                latency: configuration.detection?.latencyTestEndpoint ?? "",
                speed: configuration.detection?.speedTestEndpoint ?? "",
            };

            setState(configuration);
        };

        get(); // Run it.
    }, []);

    return (
        <ConfigurationContext.Provider value={state}>
            {props.children}
        </ConfigurationContext.Provider>
    );
};
